import {useDebugValue} from 'react';

function useDestinationSelectors(data) {
    const {
        latestValues: {
            destination,
            subDestination,
            listingProps
        }
    } = data;

    function getFilter() {
        return (
            subDestination && subDestination.filter
                ? subDestination.filter.id
                : null
        );
    }

    function isListingSearch() {
        return !!listingProps;
    }

    function isValid() {
        return !!destination;
    }

    const result = {
        getFilter,
        isListingSearch,
        isValid
    };

    useDebugValue(result);

    return result;
}

export {useDestinationSelectors};
